import { Box, Button, Modal } from '@mui/material'
import React from 'react'
import StylistImage from '../assets/imgs/profile-screen-images/stylist-image.png'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const BecomeAStylistModal = ({
  toggleBecomeAStylistModal,
  handleBecomeAStylistModal,
}) => {
  return (
    <div>
      <Modal
        open={toggleBecomeAStylistModal}
        onClose={() => handleBecomeAStylistModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="about-me-modal">
          <div className="m-0 text-center">
            <h3 className="fs-24 font-weight-bold">Become a Stylist</h3>
            <img src={StylistImage} className="my-3" alt="Stylist Image" />
            <p className="fs-24 color-primary mt-3">
              Make Money By <br /> Providing Services
            </p>
            <p className="fs-14 mt-3 text-left">
              Duis porta, ligula rhoncus euismod pretium, nisi tellus eleifend
              odio, luctus viverra sem dolor id sem. Maecenas a venenatis enim,
              quis porttitor magna. Etiam nec rhoncus neque. Sed quis ultrices
              eros. Curabitur sit amet eros eu arcu consectetur pulvinar.
              Aliquam sodales, turpis eget tristique tempor, sapien lacus
              facilisis diam, molestie efficitur sapien velit nec magna.
              Maecenas interdum efficitur tempor
            </p>
            <Button
              disableElevation
              fullWidth
              id="btn-primary-no-shadow"
              className="pointer mt-5"
            >
              Create a Stylist Profile
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default BecomeAStylistModal
